import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Recruiter, Studies} from '../model/recruiter.model';
import { StudiesService } from '../../shared/services/studies.service';
import { NgForm} from '@angular/forms';
import {RecruiterServices} from '../../shared/services/recruiter.services';
import {MatSidenav} from '@angular/material/sidenav';
import { NotifierService } from 'angular-notifier';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],

})
export class CreateRecruiterComponent implements OnInit {
  @Input() allStudies: Studies ;
  @Input() access: any;
  @ViewChild ('testing', {static: false}) testing: any;
  @Input() inputSideNav: MatSidenav;
  @Output() close: EventEmitter<any> = new EventEmitter();

  inputSide: MatSidenav;
  countryList:any = [];

  name = 'praveen';
  fetchedStudies: Studies;
  formatedStudy: any = [];
  private recruiter: Recruiter;
  public selectedStudy = [];
  formStatus = false;
  statusClass: string;
  responseMessage: string;
  responseIcon: string;
  active = true;
  phoneRegex:string;
  country:any;
  countryCode:string = '+91';

  constructor( private studies: StudiesService,
    private notifier: NotifierService, 
    private router: Router,
    private logerror: LoginService,
    private recruiterService: RecruiterServices) { }

  ngOnInit() {
    this.getAllCountry();
    this.inputSide =  this.inputSideNav;
    this.recruiter = new Recruiter({
      recruiter_name: '', phone: '', employee_id: '', recruiter_code: '', country_id: ''
    });
    this.fetchedStudies = this.allStudies;
    this.formatStudyFn (this.fetchedStudies.result );
  }

  updatePhone(){
    this.recruiter['country_id'] = this.country['id'];
    this.phoneRegex = this.country['phone_regex'];
    this.countryCode = this.country['extension'];
  }

  formatStudyFn(value: any) {
    value.filter( study => {
      this.formatedStudy.push({name: study.study_details.study_name, id: study.study_details.id});
    });
  }

  selectedStudyHandler($event: any) {
    this.selectedStudy = $event;
  }


  onCreateRecruiter(f: NgForm) {
    // this.recruiter['phone'] = this.countryCode + this.recruiter['phone'];
    this.recruiterService.addRecruiter(this.recruiter).subscribe(
      data => {
        if ( data.responseCode == 1){
          this.statusClass = 'success';
          this.showNotification('success','Successfully Added');
          this.responseIcon ='check_circle_outline';
          this.formStatus = true;
          const recruiter =  data.result.result;
          this.responseMessage = data.message
          this.assignStudy(recruiter, this.selectedStudy);
        //  this.resetForm(f);
          this.onClose();

        }
        else{
          this.statusClass = 'fail';
          this.responseIcon ='error_outline';
          this.responseMessage = data.message
          this.showNotification('error', data.message);
          this.formStatus = true;

        }
      },
      (error) => {
        if(error.status == 401){
          this.router.navigate(['home/access-denied']);
        }else{
          this.showNotification('error', 'Something went wrong');
        }
      },
      () => {

      }
    );
  }


  assignStudy(recruiter_id, selectedStudy) {
    const selectedStudyId = [];
    selectedStudy.filter(function (study) {
      selectedStudyId.push(study.id);
    });
    this.studies.assignStudy({recruiter_id: recruiter_id, study: selectedStudyId.toString()}).subscribe(
      result => {
      },
      error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
      }
    );
  }
  resetForm(f: NgForm) {
    f.form.reset();
    this.active = false;
    setTimeout(() => this.active = true, 0);
  }
  onClose() {
    this.close.emit();
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  scrollToTarget(element: HTMLElement){
    element.scrollIntoView(true);
  }

  getAllCountry(){
    this.recruiterService.getAllCountry().subscribe((data)=>{
      this.countryList = data['countries'];
    },
    error=>{
      if(error.status == 401){
        this.router.navigate(['home/access-denied']);
      }
    });
  }
  public showNotification( type: string, message: string ): void {
		this.notifier.notify( type, message );
	}

	public hideOldestNotification(): void {
		this.notifier.hideOldest();
	}

}
